/**
 * Frequently Bought Together — totals + variant-selection modal + multi-item cart add.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents, moneyFormat, currency) {
    var value = (Number(cents) || 0) / 100;
    var amount = value.toFixed(2);
    var format = moneyFormat || '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (err) {}
    }

    if (format) {
      var formatted = format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value)))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
      if (formatted !== format) return formatted;
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(value);
    } catch (err2) {
      return '$' + amount;
    }
  }

  function isColorOption(name) {
    return /colou?r|shade|tone|swatch/i.test(String(name || ''));
  }

  function isSizeOption(name) {
    return /size|fit|length|waist|inseam/i.test(String(name || ''));
  }

  function parseProductJson(row) {
    var el = row.querySelector('[data-gf-fbt-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function checkedRows(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-gf-fbt-row]')).filter(function (row) {
      var check = row.querySelector('[data-gf-fbt-check]');
      return !!(check && check.checked);
    });
  }

  function cartRows(root) {
    return checkedRows(root).filter(function (row) {
      var check = row.querySelector('[data-gf-fbt-check]');
      return check && !check.disabled && row.getAttribute('data-available') === 'true';
    });
  }

  function getSelectableOptions(product) {
    return (product.options || []).filter(function (opt) {
      if (!opt || !opt.values || opt.values.length <= 1) return false;
      return isColorOption(opt.name) || isSizeOption(opt.name);
    });
  }

  function optionKind(name) {
    if (isColorOption(name)) return 'color';
    if (isSizeOption(name)) return 'size';
    return 'other';
  }

  function findMatchingVariants(product, selections) {
    return (product.variants || []).filter(function (variant) {
      return (product.options || []).every(function (opt, index) {
        var kind = optionKind(opt.name);
        if (kind === 'other' || !opt.values || opt.values.length <= 1) return true;
        var selected = selections[opt.name];
        if (!selected) return true;
        return variant.options[index] === selected;
      });
    });
  }

  function findVariant(product, selections) {
    var selectable = getSelectableOptions(product);
    if (!selectable.length) {
      return (
        (product.variants || []).find(function (v) {
          return v.available;
        }) ||
        (product.variants || [])[0] ||
        null
      );
    }
    if (
      selectable.some(function (opt) {
        return !selections[opt.name];
      })
    ) {
      return null;
    }

    var matches = findMatchingVariants(product, selections);
    var available = matches.find(function (v) {
      return v.available;
    });
    return available || matches[0] || null;
  }

  function isValueAvailable(product, selections, optionName, value) {
    var next = Object.assign({}, selections);
    next[optionName] = value;
    return findMatchingVariants(product, next).some(function (v) {
      return v.available;
    });
  }

  function requiredSelectionsComplete(product, selections) {
    var selectable = getSelectableOptions(product);
    if (!selectable.length) return true;
    return selectable.every(function (opt) {
      return !!selections[opt.name];
    }) && !!findVariant(product, selections);
  }

  function defaultSelections(product) {
    var selections = {};
    var selectable = getSelectableOptions(product);
    selectable.forEach(function (opt) {
      var firstAvailable = (opt.values || []).find(function (value) {
        return isValueAvailable(product, selections, opt.name, value);
      });
      if (firstAvailable) selections[opt.name] = firstAvailable;
    });
    return selections;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateTotals(root) {
    var rows = checkedRows(root);
    var totalPrice = 0;
    var totalCompare = 0;
    var count = rows.length;
    var hasCompare = false;

    rows.forEach(function (row) {
      var price = Number(row.getAttribute('data-price')) || 0;
      var compare = Number(row.getAttribute('data-compare')) || 0;
      totalPrice += price;
      if (compare > price) {
        totalCompare += compare;
        hasCompare = true;
      } else if (compare > 0) {
        totalCompare += compare;
      } else {
        totalCompare += price;
      }
    });

    var moneyFormat = root.getAttribute('data-money-format') || '';
    var currency = root.getAttribute('data-currency') || 'USD';
    var countLabel = root.querySelector('[data-gf-fbt-count-label]');
    var mrpEl = root.querySelector('[data-gf-fbt-total-mrp]');
    var priceEl = root.querySelector('[data-gf-fbt-total-price]');
    var discountEl = root.querySelector('[data-gf-fbt-total-discount]');
    var addBtn = root.querySelector('[data-gf-fbt-add]');
    var addableCount = cartRows(root).length;

    if (countLabel) {
      countLabel.textContent = count === 1 ? '(1 item):' : '(' + count + ' items):';
    }

    if (priceEl) {
      priceEl.textContent = formatMoney(totalPrice, moneyFormat, currency);
    }

    if (mrpEl) {
      if (count > 0 && hasCompare && totalCompare > totalPrice) {
        mrpEl.hidden = false;
        mrpEl.textContent = formatMoney(totalCompare, moneyFormat, currency);
      } else {
        mrpEl.hidden = true;
        mrpEl.textContent = '';
      }
    }

    if (discountEl) {
      if (count > 0 && hasCompare && totalCompare > totalPrice) {
        var discount = Math.round(((totalCompare - totalPrice) / totalCompare) * 100);
        discountEl.hidden = false;
        discountEl.textContent = '(' + discount + '% OFF)';
      } else {
        discountEl.hidden = true;
        discountEl.textContent = '';
      }
    }

    if (addBtn) {
      if (addableCount <= 0) {
        addBtn.disabled = true;
        addBtn.textContent = count > 0 ? 'Add ' + count + ' items to Bag' : 'Add items to Bag';
      } else {
        addBtn.disabled = false;
        addBtn.textContent =
          addableCount === 1 ? 'Add 1 item to Bag' : 'Add ' + addableCount + ' items to Bag';
      }
    }
  }

  function getCartUi() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionsToRequest(cart) {
    var ids = ['cart-icon-bubble'];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      cart.getSectionsToRender().forEach(function (section) {
        if (section && section.id && ids.indexOf(section.id) === -1) ids.push(section.id);
      });
    } else if (document.querySelector('cart-drawer')) {
      ids.push('cart-drawer');
    }
    return ids;
  }

  function updateCartIconBubble(sectionHtml) {
    if (!sectionHtml) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var source =
      doc.getElementById('cart-icon-bubble') ||
      (doc.querySelector('.shopify-section') &&
        doc.querySelector('.shopify-section').querySelector('#cart-icon-bubble')) ||
      doc.querySelector('.shopify-section');
    if (!source) return;
    bubble.innerHTML = source.id === 'cart-icon-bubble' ? source.innerHTML : source.innerHTML;
  }

  function refreshCartSections(sectionIds) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ids = sectionIds && sectionIds.length ? sectionIds : ['cart-icon-bubble'];
    return fetch(root + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) {
        if (!r.ok) throw new Error('Section refresh failed');
        return r.json();
      })
      .then(function (sections) {
        if (!sections) return;
        updateCartIconBubble(sections['cart-icon-bubble']);
        var cart = getCartUi();
        if (cart && typeof cart.renderContents === 'function' && sections['cart-drawer']) {
          try {
            cart.renderContents({ sections: sections });
          } catch (err) {
            /* header bubble already updated */
          }
        }
      });
  }

  function syncCartUiAfterAdd(data) {
    // Prefer updating the header bubble from the add response.
    // Do not call cart.renderContents here: multi-item responses can throw in
    // Dawn's getSectionInnerHTML and falsely surface as "Try again", and opening
    // the drawer under the FBT modal is unwanted.
    return Promise.resolve()
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          return publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gf-fbt',
            cartData: data,
          });
        }
      })
      .then(function () {
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          updateCartIconBubble(data.sections['cart-icon-bubble']);
          return;
        }
        return refreshCartSections(['cart-icon-bubble']);
      })
      .catch(function () {
        return refreshCartSections(['cart-icon-bubble']);
      });
  }

  function setGoToBagState(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-added', 'is-go-bag');
    btn.disabled = false;
    btn.removeAttribute('data-gf-fbt-submit');
    btn.setAttribute('data-gf-fbt-go-bag', 'true');
    btn.textContent = 'GO TO BAG';
  }

  function addItemsToCart(items, btn, onDone) {
    if (!items.length || !window.routes || !window.routes.cart_add_url) {
      if (onDone) onDone(false);
      return;
    }
    if (btn.getAttribute('data-gf-fbt-busy') === 'true') return;

    btn.setAttribute('data-gf-fbt-busy', 'true');
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.classList.remove('is-added', 'is-go-bag');
    var originalText = btn.textContent;

    var cart = getCartUi();
    var body = {
      items: items,
      sections: sectionsToRequest(cart),
      sections_url: window.location.pathname,
    };
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(btn);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data || {};
        // Genuine Shopify cart API errors only.
        if (!result.ok || data.status || data.errors) {
          var message =
            data.description ||
            data.message ||
            (typeof data.errors === 'string' ? data.errors : '') ||
            'Could not add to cart';
          throw new Error(message);
        }

        return syncCartUiAfterAdd(data).then(function () {
          setGoToBagState(btn);
          btn.removeAttribute('data-gf-fbt-busy');
          if (onDone) onDone(true, data);
        });
      })
      .catch(function (err) {
        btn.removeAttribute('data-gf-fbt-busy');
        btn.classList.remove('is-loading');
        btn.textContent = 'Try again';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.setAttribute('data-gf-fbt-submit', 'true');
        }, 1500);
        if (onDone) onDone(false, err);
      });
  }

  function createModalController(root) {
    var modal = root.querySelector('[data-gf-fbt-modal]');
    var dialog = root.querySelector('[data-gf-fbt-modal-dialog]');
    var titleEl = root.querySelector('[data-gf-fbt-modal-title]');
    var progressEl = root.querySelector('[data-gf-fbt-modal-progress]');
    var bodyEl = root.querySelector('[data-gf-fbt-modal-body]');
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var currency = root.getAttribute('data-currency') || 'USD';
    var state = null;
    var lastFocus = null;

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('gf-fbt-modal-open');
      state = null;
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function openModal(products) {
      if (!modal || !products.length) return;
      lastFocus = document.activeElement;
      state = {
        products: products,
        index: 0,
        selections: products.map(function (p) {
          return defaultSelections(p);
        }),
        chosenVariants: products.map(function () {
          return null;
        }),
      };
      products.forEach(function (product, i) {
        var variant = findVariant(product, state.selections[i]);
        state.chosenVariants[i] = variant;
      });
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gf-fbt-modal-open');
      render();
      var closeBtn = modal.querySelector('[data-gf-fbt-modal-close]');
      if (closeBtn) closeBtn.focus();
    }

    function renderProgress() {
      if (!progressEl || !state) return;
      var html = '';
      state.products.forEach(function (product, i) {
        var current = i === state.index;
        var done = i < state.index;
        var cls = 'gf-fbt-modal__step';
        if (current) cls += ' is-current';
        if (done) cls += ' is-done';
        html +=
          '<div class="' +
          cls +
          '" data-step="' +
          i +
          '">' +
          '<span class="gf-fbt-modal__step-num" aria-hidden="true">' +
          (done ? '✓' : String(i + 1)) +
          '</span>' +
          '<span class="gf-fbt-modal__step-label">Item ' +
          (i + 1) +
          '</span>' +
          '</div>';
        if (i < state.products.length - 1) {
          html += '<div class="gf-fbt-modal__step-line" aria-hidden="true"></div>';
        }
      });
      progressEl.innerHTML = html;
    }

    function renderOptionGroup(product, opt, selections) {
      var kind = optionKind(opt.name);
      var selected = selections[opt.name] || '';
      var label =
        '<div class="gf-fbt-modal__option-label">' +
        escapeHtml(opt.name) +
        (selected ? ': <strong>' + escapeHtml(selected) + '</strong>' : '') +
        '</div>';

      if (kind === 'color') {
        var swatches = (opt.values || [])
          .map(function (value) {
            var available = isValueAvailable(product, selections, opt.name, value);
            var isSelected = selected === value;
            var cls = 'gf-fbt-modal__swatch';
            if (isSelected) cls += ' is-selected';
            if (!available) cls += ' is-unavailable';
            var variantForImage = findMatchingVariants(
              product,
              Object.assign({}, selections, { [opt.name]: value })
            )[0];
            var img =
              (variantForImage && variantForImage.featured_image) || product.image || '';
            return (
              '<button type="button" class="' +
              cls +
              '" data-gf-fbt-option-name="' +
              escapeHtml(opt.name) +
              '" data-gf-fbt-option-value="' +
              escapeHtml(value) +
              '"' +
              (available ? '' : ' disabled') +
              ' aria-pressed="' +
              (isSelected ? 'true' : 'false') +
              '" title="' +
              escapeHtml(value) +
              '">' +
              (img
                ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(value) + '" width="44" height="44" loading="lazy">'
                : '<span class="gf-fbt-modal__swatch-text">' + escapeHtml(value) + '</span>') +
              '</button>'
            );
          })
          .join('');
        return (
          '<div class="gf-fbt-modal__option" data-option-kind="color">' +
          label +
          '<div class="gf-fbt-modal__swatches">' +
          swatches +
          '</div></div>'
        );
      }

      var pills = (opt.values || [])
        .map(function (value) {
          var available = isValueAvailable(product, selections, opt.name, value);
          var isSelected = selected === value;
          var cls = 'gf-fbt-modal__pill';
          if (isSelected) cls += ' is-selected';
          if (!available) cls += ' is-unavailable';
          return (
            '<button type="button" class="' +
            cls +
            '" data-gf-fbt-option-name="' +
            escapeHtml(opt.name) +
            '" data-gf-fbt-option-value="' +
            escapeHtml(value) +
            '"' +
            (available ? '' : ' disabled') +
            ' aria-pressed="' +
            (isSelected ? 'true' : 'false') +
            '">' +
            escapeHtml(value) +
            '</button>'
          );
        })
        .join('');

      return (
        '<div class="gf-fbt-modal__option" data-option-kind="size">' +
        label +
        '<div class="gf-fbt-modal__pills">' +
        pills +
        '</div></div>'
      );
    }

    function renderActiveCard() {
      var product = state.products[state.index];
      var selections = state.selections[state.index];
      var variant = findVariant(product, selections);
      state.chosenVariants[state.index] = variant;

      var image = (variant && variant.featured_image) || product.image || '';
      var price = variant ? variant.price : 0;
      var compare = variant ? variant.compare_at_price || 0 : 0;
      var onSale = compare > price && price > 0;
      var discount = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
      var selectable = getSelectableOptions(product);
      var canProceed = requiredSelectionsComplete(product, selections) && variant && variant.available;
      var isLast = state.index === state.products.length - 1;
      var count = state.products.length;

      var optionsHtml = selectable
        .map(function (opt) {
          return renderOptionGroup(product, opt, selections);
        })
        .join('');

      if (!selectable.length) {
        optionsHtml =
          '<p class="gf-fbt-modal__ready">No options to select for this product.</p>';
      }

      var pricingHtml =
        '<div class="gf-fbt-modal__pricing">' +
        (onSale
          ? '<span class="gf-fbt-modal__mrp">' +
            formatMoney(compare, moneyFormat, currency) +
            '</span>'
          : '') +
        '<span class="gf-fbt-modal__price">' +
        formatMoney(price, moneyFormat, currency) +
        '</span>' +
        (onSale && discount > 0
          ? '<span class="gf-fbt-modal__discount">(' + discount + '% OFF)</span>'
          : '') +
        '</div>';

      var navHtml =
        '<div class="gf-fbt-modal__nav">' +
        (state.index === 0
          ? '<span class="gf-fbt-modal__prev gf-fbt-modal__prev--spacer" aria-hidden="true"></span>'
          : '<button type="button" class="gf-fbt-modal__prev" data-gf-fbt-prev>&larr; Previous</button>') +
        (isLast
          ? '<button type="button" class="gf-fbt-modal__next" data-gf-fbt-submit' +
            (canProceed ? '' : ' disabled') +
            '>' +
            (count === 1 ? 'Add 1 item to Bag' : 'Add ' + count + ' items to Bag') +
            '</button>'
          : '<button type="button" class="gf-fbt-modal__next" data-gf-fbt-next' +
            (canProceed ? '' : ' disabled') +
            '>Next &rarr;</button>') +
        '</div>';

      return (
        '<div class="gf-fbt-modal__card is-active">' +
        '<div class="gf-fbt-modal__product">' +
        '<div class="gf-fbt-modal__media">' +
        (image
          ? '<img src="' +
            escapeHtml(image) +
            '" alt="' +
            escapeHtml(product.title) +
            '" width="96" height="96" loading="lazy">'
          : '<div class="gf-fbt-modal__media-ph" aria-hidden="true"></div>') +
        '</div>' +
        '<div class="gf-fbt-modal__meta">' +
        '<p class="gf-fbt-modal__product-title">' +
        escapeHtml(product.title) +
        '</p>' +
        pricingHtml +
        '</div></div>' +
        '<div class="gf-fbt-modal__options">' +
        optionsHtml +
        '</div>' +
        navHtml +
        '</div>'
      );
    }

    function render() {
      if (!state || !bodyEl || !titleEl) return;
      var count = state.products.length;
      titleEl.textContent =
        count === 1 ? 'Add to Bag (1 item)' : 'Add to Bag (' + count + ' items)';
      renderProgress();
      bodyEl.innerHTML = renderActiveCard();
    }

    function selectOption(name, value) {
      if (!state) return;
      var product = state.products[state.index];
      var selections = Object.assign({}, state.selections[state.index]);
      selections[name] = value;

      // Clear dependent selections that became invalid
      getSelectableOptions(product).forEach(function (opt) {
        if (opt.name === name) return;
        var current = selections[opt.name];
        if (current && !isValueAvailable(product, selections, opt.name, current)) {
          delete selections[opt.name];
        }
      });

      state.selections[state.index] = selections;
      state.chosenVariants[state.index] = findVariant(product, selections);
      render();
    }

    function goNext() {
      if (!state) return;
      var product = state.products[state.index];
      var selections = state.selections[state.index];
      if (!requiredSelectionsComplete(product, selections)) return;
      var variant = findVariant(product, selections);
      if (!variant || !variant.available) return;
      state.chosenVariants[state.index] = variant;
      if (state.index < state.products.length - 1) {
        state.index += 1;
        render();
      }
    }

    function goPrev() {
      if (!state || state.index <= 0) return;
      state.index -= 1;
      render();
    }

    function submitCart(btn) {
      if (!state) return;
      var product = state.products[state.index];
      var selections = state.selections[state.index];
      if (!requiredSelectionsComplete(product, selections)) return;
      var lastVariant = findVariant(product, selections);
      if (!lastVariant || !lastVariant.available) return;
      state.chosenVariants[state.index] = lastVariant;

      var items = state.chosenVariants
        .filter(function (v) {
          return v && v.available;
        })
        .map(function (v) {
          return { id: Number(v.id), quantity: 1 };
        });

      if (!items.length) return;

      addItemsToCart(items, btn, function (ok) {
        // Keep modal open on success so GO TO BAG is visible.
        // Do not treat section-render issues as add failures (handled inside addItemsToCart).
        if (!ok) return;
      });
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-gf-fbt-modal-close]')) {
          closeModal();
          return;
        }
        var goBag = e.target.closest('[data-gf-fbt-go-bag]');
        if (goBag) {
          e.preventDefault();
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        var optionBtn = e.target.closest('[data-gf-fbt-option-value]');
        if (optionBtn && !optionBtn.disabled) {
          selectOption(
            optionBtn.getAttribute('data-gf-fbt-option-name'),
            optionBtn.getAttribute('data-gf-fbt-option-value')
          );
          return;
        }
        if (e.target.closest('[data-gf-fbt-next]')) {
          goNext();
          return;
        }
        if (e.target.closest('[data-gf-fbt-prev]')) {
          goPrev();
          return;
        }
        var submitBtn = e.target.closest('[data-gf-fbt-submit]');
        if (submitBtn && !submitBtn.disabled && submitBtn.getAttribute('data-gf-fbt-busy') !== 'true') {
          submitCart(submitBtn);
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!state || !modal || modal.hidden) return;
      if (e.key === 'Escape') closeModal();
    });

    return {
      open: openModal,
      close: closeModal,
    };
  }

  function initRoot(root) {
    if (!root || root._gfFbtReady) return;
    root._gfFbtReady = true;

    var modalApi = createModalController(root);

    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-gf-fbt-check]')) return;
      updateTotals(root);
    });

    var addBtn = root.querySelector('[data-gf-fbt-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var rows = cartRows(root);
        var products = rows
          .map(function (row) {
            return parseProductJson(row);
          })
          .filter(Boolean);
        if (!products.length) return;
        modalApi.open(products);
      });
    }

    updateTotals(root);
  }

  ready(function () {
    document.querySelectorAll('[data-gf-fbt]').forEach(initRoot);
  });
})();
